export default __webpack_public_path__ + "./images/gu.6a0f3341.png";